import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const sendMessageToAI = async (message, currentLesson, currentProblems, currentCode) => {

  const body = {
    "question": message,
    "currentLesson": currentLesson,
    "currentProblems": currentProblems,
    "currentCode": currentCode
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}


export const sendAiRewriteLessonRequest = async (message, currentLesson, currentProblems, currentCode) => {

  const body = {
    "question": message,
    "currentLesson": currentLesson,
    "currentProblems": currentProblems,
    "currentCode": currentCode
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-rewrite-lesson", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}


export const sendAiRewritePPRequest = async (message, currentLesson, currentProblems, currentCode) => {

  const body = {
    "question": message,
    "currentLesson": currentLesson,
    "currentProblems": currentProblems,
    "currentCode": currentCode
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-rewrite-pp", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}


export const requestAiUserIntention = async (pageContex, message) => {

  const body = {
    "pageContex": pageContex,
    "question": message
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-user-intention", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}




export const requestAiHelpPP = async (message, currentLesson, currentProblems, currentCode) => {

  const body = {
    "question": message,
    "currentLesson": currentLesson,
    "currentProblems": currentProblems,
    "currentCode": currentCode
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-help-pp", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}



export const requestAiBasicQuestion = async (message) => {

  const body = {
    "question": message
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-basic-question", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}


export const requestAiContentHelp = async (message, currentLesson, currentProblems, currentCode, helpMode) => {

  const body = {
    "question": message,
    "currentLesson": currentLesson,
    "currentProblems": currentProblems,
    "currentCode": currentCode,
    "helpMode": helpMode
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-content-help", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}


export const requestAiNavigation = async (message) => {

  const body = {
    "question": message,
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-navigation", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}


export const requestAIGettingStarted = async (message) => {

  const body = {
    "question": message,
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-started", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}


export const requestInitializeLesson = async (course, title, lang) => {

  const body = {
    "title": title,
    "course": course,
    "lang": lang
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-lesson", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}



export const requestAIInitializePracticeProblems = async (course, title, currentLesson, lang, conceptual = false) => {

  const body = {
    "title": title,
    currentLesson: currentLesson,
    course: course,
    "lang": lang,
    conceptual: conceptual
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-problems", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}

export const requestAIPredeterminedProblems = async (title, currentLessonContent) => {

  const body = {
    title: title,
    currentLessonContent: currentLessonContent
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ai-predetermined-problems", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}

export const requestQuizFromAI = async (completedLessons) => {

  const body = {
    completedLessons: completedLessons
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-quiz", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}


export const requestAlreadyLoggedInAiMessage = async () => {

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/message-already-loggedin");

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };

}

export const requestAlreadyLoggedOutAiMessage = async () => {

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/message-already-loggedout");

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };

}


export const requestAiHelpLesson = async (message, currentLesson, currentProblems, currentCode) => {

  const body = {
    "question": message,
    "currentLesson": currentLesson,
    "currentProblems": currentProblems,
    "currentCode": currentCode
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-help-lesson", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}


export const requestAiHelpPracticeProblems = async (message, currentLesson, currentProblems, currentCode) => {

  const body = {
    "question": message,
    "currentLesson": currentLesson,
    "currentProblems": currentProblems,
    "currentCode": currentCode
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-help-problems", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}


export const requestAiHelpDebugCode = async (message, currentLesson, currentProblems, currentCode, consoleOutput) => {

  const body = {
    "question": message,
    "currentLesson": currentLesson,
    "currentProblems": currentProblems,
    "currentCode": currentCode,
    "consoleOutput": consoleOutput
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-help-debug", body);

    const aiMessage = response.data.response;
    return aiMessage;

  } catch (error) {
    console.error("Error fetching user response:", error);
  };
}


// ===========================================================================
// Claude Course (CC_M1_L*) — "Use Claude Like a Developer"
// ===========================================================================

/**
 * Generate (and cache server-side) a Claude Course lesson definition.
 * Returns the lesson definition object { lessonID, title, type, language,
 * lessonMarkdown, systemPromptForClaude, exercisePrompt, hint, ... }.
 */
export const requestInitClaudeCourseLesson = async (lessonID, title, type, language, layout, grading, locale) => {

  const body = {
    lessonID,
    title,
    type,
    language: language || "",
    layout: layout || "",
    grading: grading || "",
    locale: locale || "en"
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-init-prompt-lesson", body);
    return response.data.response;
  } catch (error) {
    console.error("Error initializing Claude Course lesson:", error);
  }
}

/**
 * Live student-to-Claude chat used inside the Prompt Lab.
 * Returns { text, usage }.
 */
export const requestPromptLabClaude = async (systemPrompt, messages, lessonID, token) => {

  // `token` is optional: when sent, the backend looks up the student's own app
  // project and prepends it to the system prompt so Claude uses THEIR app for
  // examples. Anonymous/logged-out visitors simply omit it.
  const body = {
    systemPrompt,
    messages,
    lessonID,
    token
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/prompt-lab-claude", body);
    return response.data.response;
  } catch (error) {
    console.error("Error calling Prompt Lab Claude:", error);
  }
}

/**
 * Ask Claude to judge a concept lesson conversation against a rubric.
 * Returns { passed, score, feedback, perCriterion }.
 *
 * `usePriorSpec` opts the build-spec lessons (V2401 / V3401) into being graded
 * against what Module 1 already settled as well as this transcript.
 *
 * `gradeProject` opts the app-idea lesson (V2101 / V3101 / V4101) into being
 * graded on the "My app idea" card the student saved, with the transcript as
 * supporting evidence only — that lesson's work happens in the form.
 *
 * Both are loaded server-side from the token; the client only asks for them, so
 * a caller can't post its own "what the student already did" and pass any rubric.
 */
export const requestJudgePromptLesson = async (lessonID, rubric, conversation, locale, options = {}) => {

  const body = {
    lessonID,
    rubric,
    conversation,
    locale: locale || "en",
    token: options.token,
    usePriorSpec: !!options.usePriorSpec,
    gradeProject: !!options.gradeProject
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/ask-ai-judge-prompt", body);
    return response.data.response;
  } catch (error) {
    console.error("Error judging Claude Course lesson:", error);
  }
}


/**
 * What the student already settled about their app in Module 1, slot by slot, so
 * Module 4's build-spec lesson can teach and grade only the gaps.
 *
 * Returns { spec, covered } — `covered` keys are the BUILD_SPEC_SLOTS ids shared
 * with components/PromptLabHub/buildSpecLesson.js. Never throws: an anonymous
 * visitor, a student who skipped Module 1, or an unreachable backend all yield
 * empty coverage, which renders the lesson exactly as it was before this existed.
 */
export const requestBuildSpecContext = async (token, conversation) => {

  try {
    const body = { token };
    // Sent only at the end of the lesson, so the spec written into the app they
    // download includes what they decided HERE, not just in Module 1.
    if (Array.isArray(conversation) && conversation.length > 0) body.conversation = conversation;

    const response = await axios.post(API_BASE_URL + "/codenec/build-spec-context", body);
    return response.data.response || { spec: null, covered: {} };
  } catch (error) {
    console.error("Error loading build spec context:", error);
    return { spec: null, covered: {} };
  }
}